import { DataBean } from "../DataBean";


export class RoleGroupItem extends DataBean {



}